import * as React from "react";
import { Row, Col } from "antd";
import { ActiveTradingAccountStreamingOpenPositionsGrid } from "./ActiveTradingAccountStreamingOpenPositionsGrid";
import { ActiveTradingAccountStreamingOpenTradesByMarketAndValueDateGrid } from "../Trades/ActiveTradingAccountStreamingOpenTradesByMarketAndValueDateGrid";
import { TradesByMarketAndValueDateGrid } from "../Trades/TradesByMarketAndValueDateGrid";
import { Position } from "swan-public-api-client";
import { WrappedComponentProps, injectIntl } from "react-intl";

interface State {
  marketKey?: string;
  marketName?: string;
}

class ActiveTradingAccountStreamingOpenPositionsWithTradesByMarketAndValueDateGridsCmp extends React.PureComponent<
  WrappedComponentProps,
  State
> {
  constructor(props: WrappedComponentProps) {
    super(props);
    this.state = {
      marketKey: undefined,
      marketName: undefined
    };
  }

  public render() {
    const byMarket = this.state.marketKey ? (
      <ActiveTradingAccountStreamingOpenTradesByMarketAndValueDateGrid
        marketKey={this.state.marketKey}
        bordered={false}
        pagination={{ position: "bottom", pageSize: 10 }}
        title={this.state.marketName}
      />
    ) : (
      <TradesByMarketAndValueDateGrid
        trades={[]}
        marketKey=""
        bordered={false}
        pagination={false}
        title={true}
        locale={{
          emptyText: this.props.intl.formatMessage({
            id:
              this.state.marketKey !== undefined
                ? "openPositionsWithTradesByMarketAndValueDateGrids.tradeGridEmptyText"
                : "openPositionsWithTradesByMarketAndValueDateGrids.tradeGridNoPositionSelected"
          })
        }}
      />
    );

    return (
      <div>
        <Row>
          <Col span={24}>
            <ActiveTradingAccountStreamingOpenPositionsGrid
              onSelectionChange={this.onPositionSelectionChange}
              groupByDirection={false}
              bordered={false}
              pagination={false}
              title={true}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>{byMarket}</Col>
        </Row>
      </div>
    );
  }

  private onPositionSelectionChange = (
    selectedRowKeys: string[] | number[],
    selectedRows: Position[]
  ) => {
    if (selectedRows.length === 0) {
      this.setState({
        marketKey: undefined,
        marketName: undefined
      });
      return;
    }

    const selectedPosition = selectedRows[0]; // Selection only allows 1 row
    this.setState({
      marketKey: selectedPosition.MarketKey,
      marketName: selectedPosition.MarketName
    });
  };
}

export const ActiveTradingAccountStreamingOpenPositionsWithTradesByMarketAndValueDateGrids = injectIntl(
  ActiveTradingAccountStreamingOpenPositionsWithTradesByMarketAndValueDateGridsCmp
);
